import { type Components } from '@webapp/api/integrations/client'

export type IntegrationResponseStatus = Components.Schemas.IntegrationStatus

export const IntegrationStatuses: {
  [K in IntegrationResponseStatus]
} = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
  DELETED: 'DELETED',
  INITIALIZING: 'INITIALIZING',
  DISCONNECTED: 'DISCONNECTED',
} as const
